<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CustomerService from '@/services/customer'
import { VMoney } from 'v-money'

export default {
  page: {
    title: 'Representante',
  },
  components: { Layout, PageHeader },
  directives: { money: VMoney },
  data() {
    return {
      title: 'Representante',
      agent: {},
      agentId: '',
    }
  },
  methods: {
    saveAgent() {
      if (!this.agent.name) {
        return this.$toast.info('O nome do representante é obrigatório');
      }

      let loader = this.$loading.show();


      CustomerService.createAgent(this.agent).then(() => {
        this.$toast.open('Dados atualizados');
        this.$router.push('/agents');

        loader.hide();
      }).catch(() => {
        loader.hide();
        this.$toast.error('Não foi possível efetuar a operação');
      });
    },
  },
  async mounted() {    
    let loader = this.$loading.show();

    try {
      this.agentId = this.$route.params.id;      

      if (this.agentId) {
        this.title = 'Editando Representante';

        const agentResult = await CustomerService.getAgent(this.agentId);
        this.agent = agentResult.data;
      } else {
        this.title = 'Novo Representante';
      }

      loader.hide();
    } catch (err) {
      this.$toast.error('Ocorreu um erro inesperado');
      loader.hide();
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="card">
      <div class="card-body">
        <!-- <h4 class="card-title">Dados do Produto</h4>
        <p class="card-title-desc">Preencha os dados</p> -->
        <form>
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group">
                <label for="name">Nome Completo</label>
                <input id="name" name="name" type="text" class="form-control" v-model="agent.name" />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="document_number">CPF</label>
                <input id="document_number" name="document_number" type="text" class="form-control" v-model="agent.document_number" v-mask="'###.###.###-##'" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="email">E-mail</label>
                <input id="email" name="email" type="text" class="form-control" v-model="agent.email" />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label for="phone_number">Telefone</label>
                <input
                  id="phone_number"
                  name="name"
                  type="tel"
                  class="form-control"
                  v-mask="'(##) #####-####'"
                  v-model="agent.phone_number"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row mt-4 align-items-center">
      <div class="col-sm-6">
        <router-link
          tag="a"
          to="/agents"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left mr-1"></i> Voltar para lista de representantes
        </router-link>
      </div>
      <!-- end col -->
      <div class="col-sm-6">
        <div class="text-sm-right">
          <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="saveAgent">
            <i class="mdi mdi-plus mr-1"></i> Salvar Representante
          </button>
        </div>
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>

<style lang="scss">
  .images {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .image {
      display: flex;
      flex-direction: row;
      align-items: center;

      .image-group {
        flex-direction: column;
        display: flex;
      }
    }

    img {
      height: 140px;
      margin: 20px 20px 10px 20px;
      min-height: 80px;
    }

    .new-image {
      // border: 2px dashed #a6b0cf !important;
      height: 140px;
      width: 140px;
      border-radius: 6px;
      color: #a6b0cf;
      // font-size: 30px;
      justify-content: center;
      flex-direction: column;
      display: flex;
      align-items: center;
      // padding: 10px;

      p {
        font-size: 10px;
        text-align: center;
        margin: 6px 0px 0px 0px;
      }

      // margin: 20px;
    }

    input[type="file"] {
      display: none;
    }
  }

  .nav-link.disabled {
    color: #e1e1e1;
  }
</style>